import React, { Component } from "react";
import { connect, Field } from "react-redux";

import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import Header from "../common/AuthHeader";
import { postServerDataWithPath } from "../../../action/common_action";
import { axiosInstnace, getUserData } from "../../../util/util";
import { endPoints, url } from "../../../config";
import VerifyMobile from "./verifymobilejs";
import StatusModel from "./statusupdate";
import {
  InputContact,
  DropDownContact,
  DropDown,
  DropDownContactDistrict,
} from "../../common/input";
import DSATermsPopup from "./termsandcond";
import { history } from "../../../history/history";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-toastify/dist/ReactToastify.css";
import { getState } from "../../../action/user_action";
import moment from "moment";
import Axios from "axios";

class EditKycDetailComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      userData: getUserData(),
      kycDetails: {},
      margin: { marginTop: "20px" },
      olddata: "",
      verifymobile: false,
      StatusModel: false,
      code: "",
      statusMessage: "",
      resubmit: false,
      confirmationMessage: "",
      verifycode: "",
      readonly: false,
      citylist: [],
      validation: {
        name: React.createRef(),
        fathername: React.createRef(),
        mobile: React.createRef(),
        plot: React.createRef(),
        street: React.createRef(),
        state: React.createRef(),
        city: React.createRef(),
        pincode: React.createRef(),
        aadhar: React.createRef(),
        pan: React.createRef(),
        bankaccno: React.createRef(),
        bankaccname: React.createRef(),
        ifsccode: React.createRef(),
        company: React.createRef(),
        nearStation: React.createRef(),
      },
      gstagree: false,
      statelist: [],
      basestationlist: [],
      salesuserInfo: JSON.parse(localStorage.getItem("salesUserInfo")),
      handletermsandcondpopup: false,
      accepttermsandcond: false,
      newmobileVerify: false,
      termsandcondelement: React.createRef(),
      uploadedFileArr: {},
      image: "",
      msmeregistered: '',
      kycform: {
        fathername: "",
        company: "",
        communication: {
          address: {
            plot: "",
            street: "",
          },
          city: "",
          pincode: "",
          state: "",
        },
        dob: "",
        reference: {
          name: "",
          email: "",
        },
        nearStation: "",
        category: "indvidual",
        uploadeddocuments: {
          pan: "",
          image: "",
          aadhar: "",
          addressproof: "",
          gst: "",
          cancelledcheque: "",
          msmeregistered: "",
        },
        kycdetails: {
          pannumber: "",
          aadharnumber: "",
          gstnumber: "",
        },
        socialmedia: {
          insta: "",
          facebook: "",
          linkeldn: "",
          twitter: "",
        },
        accountDetails: {
          name: "",
          no: "",
          ifsc: "",
          bankname: "",
          branchname: "",
        },
        previousKycStatuses: [],
        email: "",
        name: "",
        mobile: "",
        org_name: "",
        state: "",
        city: "",
        mentorID: "",
        kycstatus: {
          status: "",
          message: "",
          actionby: "",
          time: +new Date(),
        },
        station: "",
        mobileVerify: false,
      },
    };
  }

  handleStateCity = async (state) => {
    const response = await axiosInstnace.get(
      `${endPoints.getCities}?state=${state}`
    );
    console.log(response.data.data.data);
    let cityList = response.data.data.data;
    this.handleCityItems(cityList);
  };
  verifyMobile = (e) => {
    let { kycform } = this.state;
    kycform.mobileVerify = true;
    this.setState({
      kycform,
      verifymobile: !this.state.verifymobile,
      newmobileVerify: true,
    });
  };
  handleCityItems = (cityList) => {
    let cityListItems = cityList.map((d) => d.city);
    console.log(cityListItems);
    this.setState({
      citylist: cityListItems,
    });
  };

  //Check date for kyc
  componentDidMount = async () => {
    let data = await axiosInstnace.get(endPoints.getalldsausers, {
      params: { email: this.state.salesuserInfo.email },
    });
    let userinfo = data.data.data[0];
    delete userinfo.token;
    delete userinfo.createdAt;
    delete userinfo.usercampaigns;
    delete userinfo.updatedAt;
    delete userinfo._id;
    delete userinfo.role;
    delete userinfo.industry;
    delete userinfo.handlingCities;
    delete userinfo.joiningdate;
    delete userinfo.lastLogin;
    delete userinfo.password;
    delete userinfo.generatedpassword;
    delete userinfo.verified;
    this.setState({
      kycform: { ...this.state.kycform, ...userinfo },
      olddata: userinfo,
    });
    
    if (
      userinfo.kycstatus &&
      (userinfo.kycstatus.status === "Submitted" ||
        userinfo.kycstatus.status === "Verified")
    ) {
      this.setState({
        readonly: true,
      });
    }

    if(userinfo.uploadeddocuments && userinfo.uploadeddocuments.msmeregistered){
      this.setState({ msmeregistered: true });
    }else{
      this.setState({ msmeregistered: false });
    }
    let data2 = await axiosInstnace.get(endPoints.getStateList);
    this.setState({ statelist: data2.data.data.data });
    if (this.state.kycform.state) {
      this.handleStateCity(this.state.kycform.state);
    }
    const basestate = await axiosInstnace.get(endPoints.getCityStateRate, {
      params: { limit: false },
    });
    let result = basestate.data.data.data;
    this.setState({
      basestationlist: result.map((e) => e.station),
    });
  };
  handleArrowChange = (e) => {
    console.log(e.target.value);
    this.handleStateCity(e.target.value);
  };

  handleTermsandCond = (e) => {
    this.setState({
      handletermsandcondpopup: true,
    });
  };

  //Update the fields
  handleChange = (event) => {
    
    let { name, value } = event.target;
    let { kycDetails } = this.state;

    this.setState({
      kycDetails: {
        ...kycDetails,
        [name]: value,
      },
    });
  };
  hideConfirmation = () => {
    this.setState({
      resubmit: false,
    });
  };
  proceedtoSubmit = () => {
    this.setState({
      resubmit: false,
    });
    let { kycform } = this.state;
    kycform.kycstatus.status = "Submitted";
    kycform.kycstatus.message = "submitted Sucessfully";
    kycform.kycstatus.actionby = this.state.salesuserInfo.email;
    kycform.kycstatus.time = +new Date();
    kycform.previousKycStatuses.push(kycform.kycstatus);
    this.setState({ kycform });
    this.saveKycDetails();
  };
  handlestatuspage = () => {
    this.setState({
      StatusModel: !this.state.StatusModel,
    });
    if (this.state.code === 200) {
      window.location.reload(true);
    }
  };
  handleverifypopup = (e) => {
    if (!this.state.kycform.mobile.match(/^[6789]\d{9}$/)) {
      toast.error("Please enter a valid Phone Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    this.setState({
      verifymobile: !this.state.verifymobile,
    });
  };

  //Handling the files
  handleFiles = (event) => {
    let { name, files } = event.target;
    let { kycform } = this.state;
    kycform.uploadeddocuments[name] = files;
    
    this.setState({
      kycform,
      uploadedFileArr: {
        ...this.state.uploadedFileArr,
        ...{ [name]: files[0].name },
      },
    });
    console.log(this.state.uploadedFileArr);
  };
  saveKycDetails = async (e) => {
    if (e) {
      e.preventDefault();
    }
    if (
      this.state.kycform.mobile !== this.state.olddata.mobile &&
      !this.state.newmobileVerify
    ) {
      toast.error("Please verify your mobile number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (this.state.kycform.kycdetails.pannumber) {
      let checkPAN = await axiosInstnace.post(endPoints.checkPANDuplicateDSA, {
        pan: this.state.kycform.kycdetails.pannumber,
        email: this.state.kycform.email,
      });
      if (checkPAN.data.code !== 200) {
        delete this.state.uploadedFileArr.pan;
        let { kycform } = this.state;
        kycform.uploadeddocuments.pan = "";
        this.setState({
          kycform,
        });
        this.setState({
          StatusModel: true,
          statusMessage: checkPAN.data.message,
          code: checkPAN.data.code,
        });
        return;
      }
    }
    let formData = new FormData();
    delete this.state.kycform.uploadeddocuments.aadhar_link;
    delete this.state.kycform.uploadeddocuments.pan_link;
    delete this.state.kycform.uploadeddocuments.gst_link;
    delete this.state.kycform.uploadeddocuments.addressproof_link;
    delete this.state.kycform.uploadeddocuments.cancelledcheque_link;
    delete this.state.kycform.uploadeddocuments.image_link;
    delete this.state.kycform.mentorname;
    delete this.state.kycform.mentornum;
    delete this.state.kycform.lastActiveSession;
    formData.append("aadhar", this.state.kycform.uploadeddocuments.aadhar[0]);
    formData.append("image", this.state.kycform.uploadeddocuments.image[0]);
    formData.append("pan", this.state.kycform.uploadeddocuments.pan[0]);
    formData.append(
      "addressproof",
      this.state.kycform.uploadeddocuments.addressproof[0]
    );
    formData.append(
      "cancelledcheque",
      this.state.kycform.uploadeddocuments.cancelledcheque[0]
    );
    formData.append("gst", this.state.kycform.uploadeddocuments.gst[0]);
    formData.append("msmeregistered", this.state.kycform.uploadeddocuments.msmeregistered[0]);
    let { kycform } = this.state;
    
    kycform.uploadeddocuments.aadhar =
      typeof kycform.uploadeddocuments.aadhar === "string" ||
      kycform.uploadeddocuments.aadhar instanceof String
        ? kycform.uploadeddocuments.aadhar
        : "";
    kycform.uploadeddocuments.pan =
      typeof kycform.uploadeddocuments.pan === "string" ||
      kycform.uploadeddocuments.pan instanceof String
        ? kycform.uploadeddocuments.pan
        : "";
    kycform.uploadeddocuments.addressproof =
      typeof kycform.uploadeddocuments.addressproof === "string" ||
      kycform.uploadeddocuments.addressproof instanceof String
        ? kycform.uploadeddocuments.addressproof
        : "";
    kycform.uploadeddocuments.gst =
      typeof kycform.uploadeddocuments.gst === "string" ||
      kycform.uploadeddocuments.gst instanceof String
        ? kycform.uploadeddocuments.gst
        : "";
    kycform.uploadeddocuments.cancelledcheque =
      typeof kycform.uploadeddocuments.cancelledcheque === "string" ||
      kycform.uploadeddocuments.cancelledcheque instanceof String
        ? kycform.uploadeddocuments.cancelledcheque
        : "";
    kycform.uploadeddocuments.image =
      typeof kycform.uploadeddocuments.image === "string" ||
      kycform.uploadeddocuments.image instanceof String
        ? kycform.uploadeddocuments.image
        : "";
    kycform.dob =
      typeof kycform.dob === "string" || kycform.dob instanceof String
        ? kycform.dob
        : JSON.stringify(kycform.dob);
    formData.append("kycform", JSON.stringify(kycform));
    let status = await axiosInstnace.post(endPoints.dsauserupdate, formData);
    this.setState({
      StatusModel: true,
      statusMessage: status.data.message,
      code: status.data.code,
    });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !this.state.validation.name.current.value ||
      !this.state.validation.fathername.current.value ||
      !this.state.validation.mobile.current.value ||
      !this.state.validation.plot.current.value ||
      !this.state.validation.street.current.value ||
      !this.state.validation.state.current.value ||
      !this.state.validation.city.current.value ||
      !this.state.validation.pincode.current.value ||
      !this.state.validation.aadhar.current.value ||
      !this.state.validation.pan.current.value ||
      !this.state.validation.bankaccname.current.value ||
      !this.state.validation.bankaccno.current.value ||
      !this.state.validation.ifsccode.current.value
    ) {
      toast.error("Please fill all the mandatory details", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });

      if (!this.state.validation.name.current.value) {
        this.state.validation.name.current.style.border = "2px solid red";
      }
      if (!this.state.validation.fathername.current.value) {
        this.state.validation.fathername.current.style.border = "2px solid red";
      }
      if (!this.state.validation.mobile.current.value) {
        this.state.validation.mobile.current.style.border = "2px solid red";
      }
      if (!this.state.validation.plot.current.value) {
        this.state.validation.plot.current.style.border = "2px solid red";
      }
      if (!this.state.validation.street.current.value) {
        this.state.validation.street.current.style.border = "2px solid red";
      }
      if (!this.state.validation.state.current.value) {
        this.state.validation.state.current.style.border = "2px solid red";
      }
      if (!this.state.validation.city.current.value) {
        this.state.validation.city.current.style.border = "2px solid red";
      }
      if (!this.state.validation.pincode.current.value) {
        this.state.validation.pincode.current.style.border = "2px solid red";
      }
      if (!this.state.validation.aadhar.current.value) {
        this.state.validation.aadhar.current.style.border = "2px solid red";
      }
      if (!this.state.validation.pan.current.value) {
        this.state.validation.pan.current.style.border = "2px solid red";
      }
      if (!this.state.validation.bankaccno.current.value) {
        this.state.validation.bankaccno.current.style.border = "2px solid red";
      }
      if (!this.state.validation.bankaccname.current.value) {
        this.state.validation.bankaccname.current.style.border =
          "2px solid red";
      }
      if (!this.state.validation.ifsccode.current.value) {
        this.state.validation.ifsccode.current.style.border = "2px solid red";
      }
      return;
    }
    if (
      this.state.kycform.category === "enterprise" &&
      !this.state.validation.company.current.value
    ) {
      toast.error("Company name is mandatory for enterprise", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "2",
      });
      this.state.validation.company.current.style.border = "2px solid red";
      return;
    }
    let regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (regpan.test(this.state.validation.pan)) {
      toast.error("Please enter valid PAN number", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "2",
      });
      return;
    }
    let regsst = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
    if (
      this.state.kycform.kycdetails.gstnumber &&
      !regsst.test(this.state.kycform.kycdetails.gstnumber)
    ) {
      toast.error("Please enter valid GST number", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "2",
      });
      return;
    }
    if (!this.state.kycform.mobile.match(/^[6789]\d{9}$/)) {
      toast.error("Please enter a valid Phone Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (
      !this.state.kycform.mobileVerify ||
      this.state.kycform.mobile !== this.state.olddata.mobile
    ) {
      toast.error("Please verify your mobile number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (!this.state.validation.nearStation.current.value) {
      toast.error("Please select your Nearby BigFM Station", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    
    if (!this.state.kycform.uploadeddocuments.pan) {
      toast.error("Please upload the PAN Card Copy", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "2",
      });
      return;
    }
    if (!this.state.kycform.uploadeddocuments.aadhar) {
      toast.error("Please upload the AADHAR Card Copy", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "3",
      });
      return;
    }
    if (!this.state.kycform.uploadeddocuments.addressproof) {
      toast.error("Please upload the Address Proof", {
        position: toast.POSITION.BOTTOM_CENTER,
        hideProgressBar: true,
        autoClose: false,
        toastId: "4",
      });
      return;
    }
    if (!this.state.kycform.uploadeddocuments.cancelledcheque) {
      toast.error("Please upload the Cancelled Cheque Copy", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "5",
      });
      return;
    }
    if (!this.state.gstagree || !this.state.accepttermsandcond) {
      toast.error("Please read and accept the terms and conditions to submit", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "5",
      });
      return;
    }
    let { kycform } = this.state;
    if (kycform.kycstatus.status === "Verified") {
      this.setState({
        resubmit: true,
        confirmationMessage:
          "Are you sure you want to change the details.If you submit the changes Incentive will not be paid until BIGFM verify the details.Please click on 'PROCEED' to submit the details or click on 'CANCEL' to undo the changes",
      });
      return;
    }
    kycform.kycstatus.status = "Submitted";
    kycform.kycstatus.message = "submitted Sucessfully";
    kycform.kycstatus.actionby = this.state.salesuserInfo.email;
    kycform.kycstatus.time = +new Date();
    kycform.previousKycStatuses.push(kycform.kycstatus);
    this.setState({ kycform });
    this.saveKycDetails(e);
  };
  handleCategory = (e) => {
    
    this.setState({
      kycform: {
        ...this.state.kycform,
        category: e.target.id,
      },
    });
  };

  acceptterms = () => {
    this.setState({
      accepttermsandcond: true,
      handletermsandcondpopup: false,
    });
  };
  declineterms = () => {
    this.setState({
      accepttermsandcond: false,
      handletermsandcondpopup: false,
    });
  };
  populateBankDetails = async (e) => {
    let code = this.state.validation.ifsccode.current.value.trim();
    if (code) {
      try {
        
        let details = await Axios.get(
          `https://ifsc.razorpay.com/${code.toUpperCase()}`
        );
        let { kycform } = this.state;
        kycform.accountDetails.bankname = details.data.BANK;
        kycform.accountDetails.branchname = details.data.BRANCH;
        this.setState({ kycform });
      } catch (err) {
        console.log(err);
        toast.error("Please enter a valid ifsc code", {
          position: toast.POSITION.BOTTOM_CENTER,
          hideProgressBar: true,
          toastId: "2",
        });
      }
    }
  };

  render() {
    let { kycDetails, uploadedFileArr } = this.state;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper create_camp_container">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner detail_content">
                <div className="create_kyc_wrapper">
                  <h2 className="detail_kyc_header"> PRIMARY DETAILS</h2>
                  <div className="kycdetails_wrapper">
                    {/* <h2 className="kycheader">PRIMARY  Trade Partner DETAILS</h2> */}
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">Name</span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="name"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.name}
                            // value={kycDetails.name ? kycDetails.name : ""}
                            onChange={(e) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  name: e.target.value,
                                },
                              });
                              e.target.style.removeProperty("border");
                            }}
                            value={this.state.kycform.name}
                            placeholder="Enter Name"
                          />
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Father’s Name
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="name"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.fathername}
                            onChange={(e) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  fathername: e.target.value,
                                },
                              });
                              e.target.style.removeProperty("border");
                            }}
                            value={this.state.kycform.fathername}
                            placeholder="Enter Father’s Name"
                          />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Business Category
                        </span>
                        <div className="detailinner_input">
                          <div
                            class="own_radio"
                            style={{
                              display: "inline-block",
                              paddingRight: "9px",
                            }}
                          >
                            <input
                              class="audio_input"
                              type="radio"
                              id="indvidual"
                              readOnly={this.state.readonly}
                              checked={
                                this.state.kycform.category === "indvidual"
                              }
                              onClick={this.handleCategory}
                              name="radio-group"
                            />
                            <label class="audio_label" for="indvidual">
                              Individual
                            </label>
                          </div>
                          <div
                            class="own_radio"
                            style={{ display: "inline-block" }}
                          >
                            <input
                              class="audio_input"
                              type="radio"
                              id="enterprise"
                              readOnly={this.state.readonly}
                              checked={
                                this.state.kycform.category === "enterprise"
                              }
                              onClick={this.handleCategory}
                              name="radio-group"
                            />
                            <label class="audio_label" for="enterprise">
                              Enterprise (Firm / company)
                            </label>
                          </div>
                        </div>
                      </div>
                      {this.state.kycform.category === "enterprise" && (
                        <div className="detail_inner" style={this.state.margin}>
                          <span className="detailinner_header">
                            Company Name
                          </span>
                          <div className="detailinner_input">
                            <input
                              type="text"
                              name="company"
                              ref={this.state.validation.company}
                              onChange={(e) => {
                                this.setState({
                                  kycform: {
                                    ...this.state.kycform,
                                    company: e.target.value,
                                  },
                                });
                                e.target.style.removeProperty("border");
                              }}
                              readOnly={this.state.readonly}
                              value={this.state.kycform.company}
                              placeholder="Company Name"
                            />
                          </div>
                        </div>
                      )}
                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">Email Id</span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="email"
                            onChange={(e) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  email: e.target.value,
                                },
                              });
                            }}
                            readOnly
                            value={this.state.kycform.email}
                            placeholder="Email Id"
                          />
                        </div>
                      </div>
                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          Mobile Number
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="number"
                            name="phone_number"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.mobile}
                            onChange={(e) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  mobile: e.target.value,
                                },
                              });
                              e.target.style.removeProperty("border");
                            }}
                            value={this.state.kycform.mobile}
                            placeholder="Mobile  Number"
                          />
                          {this.state.kycform.mobile &&
                            !this.state.readonly &&
                            this.state.kycform.mobile.length == 10 &&
                            !this.state.kycform.mobileVerify && (
                              <a
                                style={{
                                  marginLeft: "-13%",
                                  color: "blue",
                                  fontSize: "13px",
                                }}
                                onClick={this.handleverifypopup}
                              >
                                Verify
                              </a>
                            )}
                          {this.state.kycform.mobile &&
                            !this.state.readonly &&
                            this.state.kycform.mobile.length == 10 &&
                            this.state.kycform.mobileVerify &&
                            this.state.olddata.mobile !==
                              this.state.kycform.mobile &&
                            !this.state.newmobileVerify && (
                              <a
                                style={{
                                  marginLeft: "-13%",
                                  color: "blue",
                                  fontSize: "13px",
                                }}
                                onClick={this.handleverifypopup}
                              >
                                Verify
                              </a>
                            )}

                          {this.state.kycform.mobileVerify &&
                            this.state.kycform.mobile.length == 10 &&
                            this.state.olddata.mobile ===
                              this.state.kycform.mobile &&
                            !this.state.readonly && (
                              <a
                                style={{
                                  marginLeft: "-13%",
                                  color: "blue",
                                  fontSize: "13px",
                                }}
                              >
                                Verified
                              </a>
                            )}
                          {this.state.kycform.mobileVerify &&
                            this.state.kycform.mobile.length == 10 &&
                            this.state.newmobileVerify &&
                            !this.state.readonly && (
                              <a
                                style={{
                                  marginLeft: "-13%",
                                  color: "blue",
                                  fontSize: "13px",
                                }}
                              >
                                Verified
                              </a>
                            )}
                        </div>
                      </div>
                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          House / Apartment / Plot number & name
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="plot"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.plot}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.communication.address.plot =
                                e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.communication &&
                              this.state.kycform.communication.address
                                ? this.state.kycform.communication.address.plot
                                : ""
                            }
                            placeholder="Plot / Flat No"
                          />
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">Street, Area</span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="Street"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.street}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.communication.address.street =
                                e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.communication &&
                              this.state.kycform.communication.address
                                ? this.state.kycform.communication.address
                                    .street
                                : ""
                            }
                            placeholder="Street Name"
                          />
                        </div>
                      </div>

                      <div class="detail_inner" style={this.state.margin}>
                        <span class="detailinner_header">State</span>
                        <div class="detailinner_input">
                          <select
                            class="packageType"
                            name="state"
                            ref={this.state.validation.state}
                            style={{ width: "90%" }}
                            value={this.state.kycform.state}
                            disabled={this.state.readonly}
                            onChange={(e) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  state: e.target.value,
                                },
                              });
                              e.target.style.removeProperty("border");
                              this.handleArrowChange(e);
                            }}
                          >
                            <option value="" disabled="">
                              Select Your State
                            </option>
                            {this.state.statelist.map((state) => {
                              return <option value={state}>{state}</option>;
                            })}
                          </select>
                        </div>
                      </div>
                      <div class="detail_inner" style={this.state.margin}>
                        <span class="detailinner_header">City</span>
                        <div class="detailinner_input">
                          <select
                            class="packageType"
                            name="city"
                            ref={this.state.validation.city}
                            style={{ width: "90%" }}
                            value={this.state.kycform.city}
                            disabled={this.state.readonly}
                            onChange={(e) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  city: e.target.value,
                                },
                              });
                              e.target.style.removeProperty("border");
                            }}
                          >
                            <option value="" disabled="">
                              Select Your City
                            </option>
                            {this.state.citylist.map((city) => {
                              return <option value={city}>{city}</option>;
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header"> Pin Code</span>
                        <div className="detailinner_input">
                          <input
                            type="number"
                            name="name"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.pincode}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.communication.pincode = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.communication
                                ? this.state.kycform.communication.pincode
                                : ""
                            }
                            placeholder="Pin Code"
                            maxLength="06"
                          />
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          Date of Birth
                        </span>
                        <div
                          className="detailinner_input"
                          style={{ width: "90%" }}
                        >
                          <DatePicker
                            onChange={(date) => {
                              this.setState({
                                kycform: {
                                  ...this.state.kycform,
                                  dob: +new Date(date),
                                },
                              });
                            }}
                            readOnly={this.state.readonly}
                            showYearDropdown
                            dateFormatCalendar={"dd MMM yyyy"}
                            selected={parseInt(this.state.kycform.dob)}
                            ref={this.state.validation.dob}
                            placeholderText="Date of Birth"
                            maxDate={new Date()}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </div>
                      </div>
                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          AADHAAR Number
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="pan_number"
                            readOnly={
                              this.state.readonly ||
                              this.state.kycform.kycstatus.status === "Verified"
                            }
                            ref={this.state.validation.aadhar}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.kycdetails.aadharnumber = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.kycdetails
                                ? this.state.kycform.kycdetails.aadharnumber
                                : ""
                            }
                            placeholder="Enter AADAAR Number"
                            maxLength="16"
                          />
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          MSME Registered
                        </span>
                        <div className="detailinner_file">
                          <div>
                            <label>
                              <input
                                type="checkbox"
                                checked={this.state.msmeregistered != ''}
                                // defaultChecked={this.state.kycform.uploadeddocuments.msmeregistered}
                                onChange={(e) => {
                                  this.setState({ msmeregistered: true });
                                }}
                                disabled={this.state.readonly}
                              />
                              &nbsp;
                              Yes
                            </label>
                            &nbsp;&nbsp;
                            
                            <label htmlFor="">
                              <input
                                type="checkbox"
                                checked={!this.state.msmeregistered}
                                // defaultChecked={!this.state.kycform.uploadeddocuments.msmeregistered}
                                onChange={(e) => {
                                  this.setState({ msmeregistered: '' });
                                }}
                                disabled={this.state.readonly}
                              />
                              &nbsp;
                              No
                            </label>

                            { this.state.msmeregistered && (
                              <div className="upload-btn-wrapper detailfile_btns">
                                &nbsp;
                                
                                <input
                                  type="file"
                                  name="msmeregistered"
                                  onChange={this.handleFiles}
                                  accept=".jpeg, .png, .jpg, .svg, .pdf"
                                  disabled={this.state.readonly}
                                />

                                <button className="btn">
                                  {this.state.msmeregistered && this.state.kycform.uploadeddocuments.msmeregistered
                                    ? "CHANGE"
                                    : "UPLOAD"}
                                </button>
                              </div>
                            ) }
                            
                          </div>
                          <div className="detailefile_name">
                            {this.state.msmeregistered && this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.msmeregistered
                              ? this.state.uploadedFileArr.msmeregistered
                              : this.state.kycform.uploadeddocuments.msmeregistered && typeof this.state.kycform.uploadeddocuments.msmeregistered === "string" 
                              ? this.state.kycform.uploadeddocuments.msmeregistered.split(
                                  "/"
                                )[
                                  this.state.kycform.uploadeddocuments.msmeregistered.split(
                                    "/"
                                  ).length - 1
                                ]
                              : ""}
                          </div>
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          AADHAAR card copy ( Self attested)
                        </span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.aadhar
                              ? this.state.uploadedFileArr.aadhar
                              : this.state.kycform.uploadeddocuments.aadhar
                              ? this.state.kycform.uploadeddocuments.aadhar.split(
                                  "/"
                                )[
                                  this.state.kycform.uploadeddocuments.aadhar.split(
                                    "/"
                                  ).length - 1
                                ]
                              : ""}
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">
                                {this.state.kycform.uploadeddocuments &&
                                this.state.kycform.uploadeddocuments.aadhar_link
                                  ? "CHANGE"
                                  : "UPLOAD"}
                              </button>
                              <input
                                type="file"
                                name="aadhar"
                                onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"
                                disabled={this.state.readonly}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          Photogragh (Please upload your passport size photo)
                        </span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.image
                              ? this.state.uploadedFileArr.image
                              : this.state.kycform.uploadeddocuments.image
                              ? this.state.kycform.uploadeddocuments.image.split(
                                  "/"
                                )[
                                  this.state.kycform.uploadeddocuments.image.split(
                                    "/"
                                  ).length - 1
                                ]
                              : ""}
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">
                                {this.state.kycform.uploadeddocuments &&
                                this.state.kycform.uploadeddocuments.image_link
                                  ? "CHANGE"
                                  : "UPLOAD"}
                              </button>
                              <input
                                type="file"
                                readOnly={this.state.readonly}
                                name="image"
                                onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"
                                disabled={this.state.readonly}
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          Address Proof copy (Self attested)
                        </span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.addressproof
                              ? this.state.uploadedFileArr.addressproof
                              : this.state.kycform.uploadeddocuments
                                  .addressproof
                              ? this.state.kycform.uploadeddocuments.addressproof.split(
                                  "/"
                                )[1]
                              : ""}
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">
                                {this.state.kycform.uploadeddocuments &&
                                this.state.kycform.uploadeddocuments
                                  .addressproof_link
                                  ? "CHANGE"
                                  : "UPLOAD"}
                              </button>
                              <input
                                type="file"
                                readOnly={this.state.readonly}
                                name="addressproof"
                                onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"
                                disabled={this.state.readonly}
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h2 className="detail_kyc_header section_sep">
                      KYC document upload
                    </h2>

                    <div className="wrapper_deials_kyc">
                      {/* {label htmlFor="Individual" && */}
                      {/* // } */}
                    </div>

                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          {" "}
                          {this.state.kycform.category === "enterprise"
                            ? "Enterprise  (Firm / company) PAN Number"
                            : "PAN Number"}
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="pan_number"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.pan}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.kycdetails.pannumber = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.kycdetails
                                ? this.state.kycform.kycdetails.pannumber
                                : ""
                            }
                            placeholder="Enter PAN Number"
                            maxLength="10"
                            pattern="[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}"
                            required
                          />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          PAN Card copy (Self attested)
                        </span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.pan
                              ? this.state.uploadedFileArr.pan
                              : this.state.kycform.uploadeddocuments.pan
                              ? this.state.kycform.uploadeddocuments.pan.split(
                                  "/"
                                )[
                                  this.state.kycform.uploadeddocuments.pan.split(
                                    "/"
                                  ).length - 1
                                ]
                              : ""}
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">
                                {this.state.kycform.uploadeddocuments &&
                                this.state.kycform.uploadeddocuments.pan_link
                                  ? "CHANGE"
                                  : "UPLOAD"}
                              </button>
                              <input
                                type="file"
                                name="pan"
                                readOnly={this.state.readonly}
                                onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"
                                disabled={this.state.readonly}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          {this.state.kycform.category === "enterprise"
                            ? "Enterprise  (Firm / company) GST Number "
                            : "GST Number "}
                          {"(Optional)"}
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            name="gst_Number"
                            readOnly={this.state.readonly}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.kycdetails.gstnumber = e.target.value;
                              this.setState({ kycform });
                            }}
                            value={
                              this.state.kycform.kycdetails.gstnumber
                                ? this.state.kycform.kycdetails.gstnumber
                                : ""
                            }
                            placeholder="Enter GST Number"
                          />
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          GST Certificate{" "}
                        </span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.gst
                              ? this.state.uploadedFileArr.gst
                              : this.state.kycform.uploadeddocuments.gst
                              ? this.state.kycform.uploadeddocuments.gst.split(
                                  "/"
                                )[
                                  this.state.kycform.uploadeddocuments.gst.split(
                                    "/"
                                  ).length - 1
                                ]
                              : ""}
                          </div>
                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">
                                {this.state.kycform.uploadeddocuments &&
                                this.state.kycform.uploadeddocuments.gst_link
                                  ? "CHANGE"
                                  : "UPLOAD"}
                              </button>
                              <input
                                type="file"
                                readOnly={this.state.readonly}
                                name="gst"
                                onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"
                                disabled={this.state.readonly}
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h2 className="detail_kyc_header section_sep">
                      BANK DETAILS
                    </h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          {" "}
                          Bank Account Number
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="number"
                            name="gst_Number"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.bankaccno}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.accountDetails.no = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.accountDetails
                                ? this.state.kycform.accountDetails.no
                                : ""
                            }
                            placeholder="Bank Account NO:"
                          />
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">Account Name</span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            // name="gst_Number"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.bankaccname}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.accountDetails.name = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.accountDetails
                                ? this.state.kycform.accountDetails.name
                                : ""
                            }
                            placeholder="Account Name"
                          />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Bank IFSC Code{" "}
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            readOnly={this.state.readonly}
                            ref={this.state.validation.ifsccode}
                            name="gst_Number"
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.accountDetails.ifsc = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.accountDetails
                                ? this.state.kycform.accountDetails.ifsc
                                : ""
                            }
                            placeholder="Bank IFSC Code  "
                          />
                          <div
                            class="search_camp"
                            style={{
                              display: "inline-block",
                              marginLeft: "-7%",
                              cursor: "pointer",
                            }}
                            onClick={this.populateBankDetails}
                          >
                            <span>
                              <img src="/assets/images/search.png" />
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">Bank Name</span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            // name="gst_Number"
                            readOnly={true}
                            ref={this.state.validation.bankname}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.accountDetails.bankname = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.accountDetails
                                ? this.state.kycform.accountDetails.bankname
                                : ""
                            }
                            placeholder="Bank Name"
                          />
                        </div>
                      </div>
                      <div className="detail_inner">
                        <span className="detailinner_header">Branch Name</span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            // name="gst_Number"
                            readOnly={true}
                            ref={this.state.validation.branchname}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.accountDetails.branchname =
                                e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.accountDetails
                                ? this.state.kycform.accountDetails.branchname
                                : ""
                            }
                            placeholder="Branch Name"
                          />
                        </div>
                      </div>

                      <div className="detail_inner" style={this.state.margin}>
                        <span className="detailinner_header">
                          Cancelled cheque upload
                        </span>
                        <div className="detailinner_file">
                          <div className="detailefile_name">
                            {this.state.uploadedFileArr &&
                            this.state.uploadedFileArr.cancelledcheque
                              ? this.state.uploadedFileArr.cancelledcheque
                              : this.state.kycform.uploadeddocuments
                                  .cancelledcheque
                              ? this.state.kycform.uploadeddocuments.cancelledcheque.split(
                                  "/"
                                )[
                                  this.state.kycform.uploadeddocuments.cancelledcheque.split(
                                    "/"
                                  ).length - 1
                                ]
                              : ""}
                          </div>

                          <div className="detailfile_btns">
                            <div className="upload-btn-wrapper">
                              <button className="btn">
                                {this.state.kycform.uploadeddocuments &&
                                this.state.kycform.uploadeddocuments
                                  .cancelledcheque_link
                                  ? "CHANGE"
                                  : "UPLOAD"}
                              </button>
                              <input
                                type="file"
                                name="cancelledcheque"
                                onChange={this.handleFiles}
                                accept=".jpeg, .png, .jpg, .svg, .pdf"
                                disabled={this.state.readonly}
                              ></input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h2 className="detail_kyc_header section_sep">
                      REFERENCE DETAILS
                    </h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Nearest BIG FM Station
                        </span>
                        <div className="detailinner_input">
                          <select
                            class="packageType"
                            name="state"
                            disabled={this.state.readonly}
                            ref={this.state.validation.nearStation}
                            value={this.state.kycform.nearStation}
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.nearStation = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                          >
                            <option value="">
                              Select Nearest BIG FM Station
                            </option>
                            {this.state.basestationlist.map((state) => {
                              return <option value={state}>{state}</option>;
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Name (Optional)
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            readOnly={this.state.readonly}
                            name="gst_Number"
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.reference.name = e.target.value;
                              this.setState({ kycform });
                            }}
                            value={
                              this.state.kycform.reference
                                ? this.state.kycform.reference.name
                                : ""
                            }
                            placeholder="Name of BIG FM Sales Person"
                          />
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Email Address (Optional)
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            readOnly={this.state.readonly}
                            name="gst_Number"
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.reference.email = e.target.value;
                              this.setState({ kycform });
                            }}
                            value={
                              this.state.kycform.reference
                                ? this.state.kycform.reference.email
                                : ""
                            }
                            placeholder="Email ID of BIG FM Sales person"
                          />
                        </div>
                      </div>
                    </div>

                    <h2 className="detail_kyc_header section_sep">
                      SOCIAL NETWORKS
                    </h2>
                    <div className="wrapper_deials_kyc">
                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Facebook profile page (Optional)
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            readOnly={this.state.readonly}
                            name="gst_Number"
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.socialmedia.facebook = e.target.value;
                              this.setState({ kycform });
                              e.target.style.removeProperty("border");
                            }}
                            value={
                              this.state.kycform.socialmedia
                                ? this.state.kycform.socialmedia.facebook
                                : ""
                            }
                            placeholder="Facebook "
                          />
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Twitter (Optional)
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            readOnly={this.state.readonly}
                            name="gst_Number"
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.socialmedia.twitter = e.target.value;
                              this.setState({ kycform });
                            }}
                            value={
                              this.state.kycform.socialmedia
                                ? this.state.kycform.socialmedia.twitter
                                : ""
                            }
                            placeholder="Twitter "
                          />
                        </div>
                      </div>

                      <div className="detail_inner">
                        <span className="detailinner_header">
                          Linkedin (Optional)
                        </span>
                        <div className="detailinner_input">
                          <input
                            type="text"
                            readOnly={this.state.readonly}
                            name="gst_Number"
                            onChange={(e) => {
                              let kycform = { ...this.state.kycform };
                              kycform.socialmedia.linkeldn = e.target.value;
                              this.setState({ kycform });
                            }}
                            value={
                              this.state.kycform.socialmedia
                                ? this.state.kycform.socialmedia.linkeldn
                                : ""
                            }
                            placeholder="Linkedin "
                          />
                        </div>
                      </div>
                    </div>
                    {this.state.kycform.kycstatus.status === "Verified" && (
                      <React.Fragment>
                        <h2 class="detail_kyc_header section_sep">
                          Trade Partner Support
                        </h2>
                        <div className="wrapper_deials_kyc">
                          <div className="detail_inner">
                            <span className="detailinner_header">
                              Mentor Name
                            </span>
                            <div className="detailinner_input">
                              <input
                                type="text"
                                readOnly={true}
                                name="gst_Number"
                                value={
                                  this.state.kycform.mentorname
                                    ? this.state.kycform.mentorname
                                    : ""
                                }
                                placeholder="Mentor Name"
                              />
                            </div>
                          </div>

                          <div className="detail_inner">
                            <span className="detailinner_header">
                              Mentor Number
                            </span>
                            <div className="detailinner_input">
                              <input
                                type="text"
                                readOnly={true}
                                name="gst_Number"
                                value={
                                  this.state.kycform.mentornum
                                    ? this.state.kycform.mentornum
                                    : ""
                                }
                                placeholder="Mentor Number"
                              />
                            </div>
                          </div>
                          <div className="detail_inner">
                            <span className="detailinner_header">
                              Mentor Email ID
                            </span>
                            <div className="detailinner_input">
                              <input
                                type="text"
                                readOnly={true}
                                name="gst_Number"
                                value={
                                  this.state.kycform.mentorID
                                    ? this.state.kycform.mentorID
                                    : ""
                                }
                                placeholder="Instagram "
                              />
                            </div>
                          </div>

                          <div className="detail_inner">
                            <span className="detailinner_header">
                              Base Station
                            </span>
                            <div className="detailinner_input">
                              <input
                                type="text"
                                readOnly={true}
                                name="gst_Number"
                                value={
                                  this.state.kycform.station
                                    ? this.state.kycform.station
                                    : ""
                                }
                                placeholder="Facebook "
                              />
                            </div>
                          </div>

                          <div className="detail_inner">
                            <span className="detailinner_header">SAP ID</span>
                            <div className="detailinner_input">
                              <input
                                type="text"
                                readOnly={true}
                                name="gst_Number"
                                value={
                                  this.state.kycform.sapId
                                    ? this.state.kycform.sapId
                                    : ""
                                }
                                placeholder="Vendor Id"
                              />
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {this.state.kycform.kycstatus.status === "Rejected" && (
                      <React.Fragment>
                        <h2 class="detail_kyc_header section_sep">
                          Rejection Comments
                        </h2>
                        <div className="wrapper_deials_kyc">
                          <div
                            className="detail_inner"
                            style={{ width: "100%" }}
                          >
                            <div className="detailinner_input">
                              <textarea
                                style={{
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                  borderRadius: "5px",
                                  width: "100%",
                                  paddingLeft: "15px",
                                }}
                                value={this.state.kycform.kycstatus.message}
                                readOnly={true}
                                name="message"
                                cols="120"
                                rows="10"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {this.state.readonly &&
                      this.state.kycform.kycstatus.status === "Verified" && (
                        <div className="save_details">
                          <button
                            onClick={(e) => {
                              this.setState({
                                readonly: false,
                              });
                            }}
                            style={{ float: "left" }}
                          >
                            EDIT
                          </button>
                        </div>
                      )}
                    {!this.state.readonly && (
                      <React.Fragment>
                        <div className="disclaimer">
                          <h6>Disclaimer*</h6>
                          <p>
                            <input
                              className="margn-rgt-10"
                              name="gstAgree"
                              onChange={(e) => {
                                this.setState({ gstagree: e.target.value });
                              }}
                              type="checkbox"
                              checked={this.state.gstagree}
                            />
                            I understand that if I do not provide GST number &
                            copy of GST certificate, I will not be entitled to
                            receive GST credit on account of all transactions on
                            this website.
                          </p>
                          <p>
                            <input
                              className="margn-rgt-10"
                              name="tand"
                              disabled={!this.state.accepttermsandcond}
                              // onChange={this.handleInputChangeTandC}
                              type="checkbox"
                              checked={this.state.accepttermsandcond}
                            />
                            Click{" "}
                            <a
                              target="_blank"
                              className="termsAndConditionsTxt"
                              style={{ cursor: "pointer" }}
                              onClick={this.handleTermsandCond}
                            >
                              here
                            </a>{" "}
                            to read and accept{" "}
                            <a
                              // href={`${fileUrl}/termsandconditions/terms-and-conditions.pdf`}
                              target="_blank"
                              className="termsAndConditionsTxt"
                              style={{ cursor: "pointer" }}
                              onClick={this.handleTermsandCond}
                            >
                              Terms and Conditions
                            </a>
                            . By clicking "Submit", I authorize company's
                            representatives to contact me or my designated
                            representative regarding the status of registration
                            as well as to provide information, offers or tips
                            about company's products and services.
                          </p>
                        </div>

                        <div className="save_details">
                          {this.state.kycform.kycstatus.status !==
                            "Verified" && (
                            <button
                              onClick={this.saveKycDetails}
                              style={{ float: "left" }}
                            >
                              SAVE AS DRAFT
                            </button>
                          )}
                          <button onClick={this.handleSubmit}> SUBMIT</button>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.handletermsandcondpopup && (
            <DSATermsPopup
              isShowing={true}
              acceptterms={this.acceptterms}
              hide={this.declineterms}
            />
          )}
          {this.state.verifymobile && (
            <VerifyMobile
              hide={this.handleverifypopup}
              isShowing={true}
              mobile={this.state.kycform.mobile}
              verify={this.verifyMobile}
            />
          )}
          {this.state.StatusModel && (
            <StatusModel
              hide={this.handlestatuspage}
              isShowing={true}
              message={this.state.statusMessage}
              code={this.state.code}
            />
          )}
          {this.state.resubmit && (
            <StatusModel
              isShowing={true}
              hide={this.hideConfirmation}
              message={this.state.confirmationMessage}
              handleSubmit={this.proceedtoSubmit}
            />
          )}
        </div>
        <ToastContainer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateKycDetails: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(EditKycDetailComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/EditKycDetails.jsx